// services/auth.service.js
import {
	signInWithEmailAndPassword,
	createUserWithEmailAndPassword,
	signOut as firebaseSignOut,
	sendPasswordResetEmail,
} from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { auth, db } from "../config/firebase";

export const authService = {
	login: async (email, password) => {
		try {
			const userCredential = await signInWithEmailAndPassword(
				auth,
				email,
				password
			);
			const userDoc = await getDoc(doc(db, "users", userCredential.user.uid));
			return {
				user: userCredential.user,
				userData: userDoc.data(),
			};
		} catch (error) {
			throw error;
		}
	},

	register: async (email, password, userData) => {
		try {
			const userCredential = await createUserWithEmailAndPassword(
				auth,
				email,
				password
			);
			// Create user document in Firestore
			await setDoc(doc(db, "users", userCredential.user.uid), {
				email,
				name: userData.name,
				role: "client",
				createdAt: new Date().toISOString(),
				...userData,
			});

			return userCredential.user;
		} catch (error) {
			throw error;
		}
	},

	logout: async () => {
		try {
			await firebaseSignOut(auth);
		} catch (error) {
			throw error;
		}
	},

	resetPassword: async (email) => {
		try {
			await sendPasswordResetEmail(auth, email);
		} catch (error) {
			throw error;
		}
	},

	getCurrentUser: async () => {
		if (!auth.currentUser) return null;

		const userDoc = await getDoc(doc(db, "users", auth.currentUser.uid));
		return {
			...auth.currentUser,
			...userDoc.data(),
		};
	},
};
